/**
 * Decodes a JWT payload and checks whether it is expired, comparing the
 * `exp` claim (seconds since epoch) against the current time.
 *
 * Returns true (expired) when the token is malformed or cannot be decoded,
 * so callers fail closed. Fonte única — não reimplemente esta checagem em
 * outro lugar (ver interceptors/auth.interceptor.ts e guards/auth.guard.ts).
 */
export function tokenEstaExpirado(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return new Date(payload.exp * 1000) <= new Date();
  } catch {
    return true;
  }
}
